$ const {
  open = false,
  localizedContent,
  className
} = input || {};
$ const {
  select_options,
  done
} = localizedContent;
<div class=['sku-selector', className]>
  <ebay-lightbox-dialog open=open on-close('handleClose') on-open('handleOpen')>
    <@header>
      ${select_options}
    </@header>
    <@footer>
      <ebay-button size='large' priority='primary' disabled=!state.selectedVariation class='footer-cta-button' on-click('handleDone')>
        ${done}
      </ebay-button>
    </@footer>
    <item-card ...state.itemCardProps/>
    <if(state.combinationSelector)>
      <variation-selector model=state.combinationSelector on-variationSelection('handleSelection') on-traitSelection('handleTraitSelection')/>
    </if>
  </ebay-lightbox-dialog>
</div>